import {gsap, Quart} from 'gsap/all';
import utils from '@/_modules/utils';

class _footer {
  //constructor() {}

  once() {
    this.el = document.getElementById('c-pagetop');
    this.el.addEventListener('click', this.anchorTop.bind(this));
  }

  init() {

  }

  anchorTop(e) {
    e.preventDefault();
    window.$scroll.scrollTo(0, {
      offset: 0,
      callback: function() {},
      duration: 400,
      easing: [0.165, 0.84, 0.44, 1],
    });
  }
}

const footer = new _footer();

export default footer;